import { Injectable } from "@angular/core";
import { Subject } from "rxjs/Rx";
import { WebSocketSubject } from "rxjs/internal-compatibility";
import { first } from "rxjs/operators";
import { Invoice } from "../model/invoice.model";
import { ShowToastrService } from "projects/sepidz-web-framework/src/lib/services";
import { TranslateService } from "@ngx-translate/core";

const CONNECTION_URL = "ws://127.0.0.1:1372/";

export class TabletPosPaymentModel {
  CompanyName: string;
  RequestType: string;
  AM: string;
  paymentType: string;
  GovID: string;
  SC: string;
  ID: string;
  constructor() {
    this.CompanyName = "SEPIDZ";
    this.RequestType = "Sale";
    this.AM = "0";
    this.paymentType = "CARD";
    this.ID = "";
    this.GovID = "";
    this.SC = "4020";
  }
}
export class TabletPosInfoModel {
  CompanyName: string;
  RequestType: string;
  constructor() {
    this.CompanyName = "SEPIDZ";
    this.RequestType = "getMerchantInfo";
  }
}
export class TabletPosPaperModel {
  CompanyName: string;
  RequestType: string;
  constructor() {
    this.CompanyName = "SEPIDZ";
    this.RequestType = "checkPaper";
  }
}
export class TabletPosReceiptBitMapModel {
  CompanyName: string;
  RequestType: string;
  invoice: TabletPosInvoiceModel;
  constructor() {
    this.CompanyName = "SEPIDZ";
    this.RequestType = "receiptBitMap";
    this.invoice = null;
  }
}
export class TabletPosResponseModel {
  compName: string;
  trxType: string;
  RS: any;
  CN: any;
  RN: any;
  SN: any;
  TN: any;
  DT: any;
  AM: any;
  PS: any;
  CP: any;
  GI: any;
  TO: any;
  BR: any;
  MI: any;
  TS: any;
  TF: any;
  ER: any;
  RC: any;
}

export class TabletPosInvoiceModel {
  num: number;
  price: number;
  discountAmount: number;
  serviceAmount: number;
  taxAmount: number;
  roundedAmount: number;
  phoneNumber: string;
  description: string;
  tableName: string;
  customerName: string;
  waiterName: string;
  guestQty: number;
  time: string;
  creationTime: string;
  usedCredit: number;
  creditPrice: number;
  sumQty: number;
  sumPrice: number;
  restaurantName: string;
  farsiDate: string;
  invoiceDetail?: TabletPosInvoiceDetailsModel[];
  constructor() {
    this.num = 0;
    this.sumQty = 0;
    this.sumPrice = 0;
    this.price = 0;
    this.discountAmount = 0;
    this.serviceAmount = 0;
    this.taxAmount = 0;
    this.roundedAmount = 0;
    this.phoneNumber = "";
    this.description = "";
    this.tableName = "";
    this.customerName = "";
    this.waiterName = "";
    this.guestQty = 0;
    this.creationTime = "";
    this.invoiceDetail = [];
    this.creditPrice = 0;
    this.farsiDate = "";
    this.usedCredit = 0;
  }
}

export class TabletPosInvoiceDetailsModel {
  sumUnitPrice: number;
  name: string;
  unitPrice: number;
  qty?: number;
  toz: string;
  constructor() {
    this.sumUnitPrice = 0;
    this.name = "";
    this.qty = 0;
    this.unitPrice = 0;
    this.toz = "";
  }
}
@Injectable()
export class TabletPosService {
  private socket$: WebSocketSubject<any>;
  private responseSubject: Subject<any> = new Subject<any>();

  constructor(private sts: ShowToastrService, private translateService: TranslateService) {}

  private connect(): void {
    this.socket$ = new WebSocketSubject(CONNECTION_URL);
    this.socket$.subscribe(
      (res) => this.responseSubject.next(res),
      (err) => this.responseSubject.error(err)
    );
  }

  public close(): void {
    if (this.socket$) {
      this.socket$.complete();
      this.socket$.unsubscribe();
    }
  }

  public async sendMessageAndWaitForResponse(data: any): Promise<any> {
    this.socket$.next(data);

    return this.responseSubject.pipe(first()).toPromise();
  }

  async tabletPosTest(): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        this.connect();
        this.sendMessageAndWaitForResponse(new TabletPosPaperModel())
          .then((response) => {
            if (response?.CP === "-1") {
              this.close();
              this.sts.showDialog(
                `${this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.CardReaderNoPaper")}`,
                `${this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.Attention")}`
              );
              reject(response);
            } else {
              this.sendMessageAndWaitForResponse(new TabletPosInfoModel())
                .then((response) => {
                  this.sts.showDialog(
                    this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.CommunicationPoseTabletDeviceEstablished"),
                    ""
                  );
                  resolve(response);
                })
                .catch((error) => {
                  this.sts.showDialog(
                    this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.NoConnectPoseTabletDevice"),
                    this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.Error")
                  );
                  this.close();
                  reject(error);
                });
            }
          })
          .catch((error) => {
            this.sts.showDialog(
              this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.NoConnectPoseTabletDevice"),
              this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.Error")
            );
            this.close();
            reject(error);
          });
      } catch (error) {
        this.sts.showDialog(
          this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.NoConnectPoseTabletDevice"),
          this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.Error")
        );
        this.close();
        reject(error);
      }
    });
  }

  async tabletPosClearing(Amount): Promise<void> {
    return await new Promise((resolve, reject) => {
      try {
        this.connect();
        this.sendMessageAndWaitForResponse(new TabletPosPaperModel())
          .then((response) => {
            if (response?.CP === "-1") {
              this.close();
              this.sts.showDialog(
                `${this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.CardReaderNoPaper")}`,
                `${this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.Attention")}`
              );
              reject(response);
            } else {
              const payment = new TabletPosPaymentModel();
              payment.AM = Amount.toString();
              this.sendMessageAndWaitForResponse(payment)
                .then((response) => {
                  if (response?.ER && response.ER !== "null") {
                    this.sts.showDialog(response.ER, this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.Error"));
                    this.close();
                    reject(response);
                  } else {
                    switch (response?.RS) {
                      case "00":
                        this.close();
                        resolve(response);
                        break;
                      case "05":
                        this.sts.showDialog(
                          this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.PaymentCanceledByUser"),
                          this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.Error")
                        );
                        this.close();
                        reject();
                        break;
                      case "51":
                        this.sts.showDialog(
                          this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.UserNotAvailable"),
                          this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.Error")
                        );
                        this.close();
                        reject();
                        break;
                      case "55":
                        this.sts.showDialog(
                          this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.WrongPasswordEntered"),
                          this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.Error")
                        );
                        this.close();
                        reject();
                        break;
                      default:
                        this.sts.showDialog(response.GI, this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.Error"));
                        this.close();
                        reject();
                        break;
                    }
                  }
                })
                .catch((error) => {
                  this.sts.showDialog(
                    this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.NoConnectPoseTabletDevice"),
                    this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.Error")
                  );
                  this.close();
                  reject(error);
                });
            }
          })
          .catch((error) => {
            this.sts.showDialog(
              this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.NoConnectPoseTabletDevice"),
              this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.Error")
            );
            this.close();
            reject(error);
          });
      } catch (error) {
        this.sts.showDialog(
          this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.NoConnectPoseTabletDevice"),
          this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.Error")
        );
        this.close();
        reject(error);
      }
    });
  }

  async tabletPosPrint(invoice: Invoice, brandName): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        this.connect();
        this.sendMessageAndWaitForResponse(new TabletPosPaperModel())
          .then((response) => {
            if (response?.CP === "-1") {
              this.close();
              this.sts.showDialog(
                `${this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.CardReaderNoPaper")}`,
                `${this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.Attention")}`
              );
              reject(response);
            } else {
              const factor = this.mapInvoice(invoice, brandName);
              this.sendMessageAndWaitForResponse(factor)
                .then((response) => {
                  this.close();
                  resolve(response);
                })
                .catch((error) => {
                  this.sts.showDialog(
                    this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.NoConnectPoseTabletDevice"),
                    this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.Error")
                  );
                  this.close();
                  reject(error);
                });
            }
          })
          .catch((error) => {
            this.sts.showDialog(
              this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.NoConnectPoseTabletDevice"),
              this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.Error")
            );
            this.close();
            reject(error);
          });
      } catch (error) {
        this.sts.showDialog(
          this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.NoConnectPoseTabletDevice"),
          this.translateService.instant("ClientApp.FrontOffice.Order.Providers.TabletPos.Error")
        );
        this.close();
        reject(error);
      }
    });
  }

  private mapInvoice(invoice: Invoice, brandName: any) {
    let factor = new TabletPosReceiptBitMapModel();
    factor.invoice = {
      num: invoice.NumberingInDate,
      customerName: invoice.CustomerTitle + " " + invoice.CustomerDisplayName,
      phoneNumber: invoice.PhoneNumber !== null ? invoice.PhoneNumber.toString() : "",
      description: invoice.Description,
      roundedAmount: invoice.RoundingAmount,
      farsiDate: invoice.ShamsiCreatedDate.slice(2) ?? "",
      creationTime: invoice.CreateDateTime.toString().slice(invoice.CreateDateTime.indexOf("T") + 1, invoice.CreateDateTime.lastIndexOf(".")) ?? "",
      discountAmount: invoice.DiscountPrice,
      price: invoice.PayableTotal,
      tableName: invoice.TableTitle ?? "",
      restaurantName: brandName,
      usedCredit: invoice.Credit,
      serviceAmount: invoice.TotalService,
      sumPrice: invoice.PayableTotal,
      waiterName: invoice.WaiterName ?? "",
      sumQty: invoice.Items.map((m) => m.Quantity).reduce((acc, cur) => acc + cur, 0),
      guestQty: invoice.NumberOfGuests ?? 0,
      taxAmount: invoice.TotalTax,
      creditPrice: 0,
      invoiceDetail: invoice.Items.map(
        (f) =>
          ({
            sumUnitPrice: f.UnitPrice,
            name: f.ItemTitle,
            qty: f.Quantity,
            toz: f.Description,
          } as TabletPosInvoiceDetailsModel)
      ),
    } as TabletPosInvoiceModel;
    return factor;
  }
}
